export const devLog = (module: string, line: number, message: any): void => {
  if (window.location.href.match(/localhost|127\.0\.0\.1/)) {
     
    console.log(`${module}, line ${line}:`, message);
  }
};
